export default {
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '50px',
  },
  gridHeading: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
};
